/**
 * Aligns with Platform {@link shared/editor/rules/checkboxes.ts} CHECKBOX_REGEX:
 * one of X, space, _, or - inside brackets, then optional body.
 *
 * GFM task lines already use a list marker (`- [*] `); orphan lines start with `[` after optional indent only.
 */

/** `- [ ]`, `* [x]`, `+ [ ]` etc. */
const ALREADY_GFM_TASK = /^\s*[-*+]\s+\[(?:[xX]| |_|-)\]\s/;

/** `[ ] foo`, `[x]`, `  [_] bar` — not yet a list item. */
const ORPHAN_TASK_LINE = /^\s*\[(?:[xX]| |_|-)\](?:\s|$)/;

export function normalizeOrphanTaskListPlainText(text: string): string {
  const lines = text.split(/\r?\n/);
  const out = lines.map((line) => {
    if (ALREADY_GFM_TASK.test(line)) {
      return line;
    }
    if (ORPHAN_TASK_LINE.test(line)) {
      return line.replace(/^(\s*)(?=\[)/, '$1- ');
    }

    return line;
  });

  return out.join('\n');
}

export function plainTextHasOrphanTaskLines(text: string): boolean {
  return text.split(/\r?\n/).some((line) => !ALREADY_GFM_TASK.test(line) && ORPHAN_TASK_LINE.test(line));
}
